import { Button } from "@capacit-com/lara-law-shared-ui";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@capacit-com/lara-law-shared-ui";
import { useSharePointContext } from "../providers/SharePointContext";
import { Item } from "../utils/workspaceItemUtils";
import MicrosoftWordIcon from "@/assets/3rd-party/word_logo.svg";
import { showErrorToast } from "@/components/custom-toasts/toasts";
import { logger } from "@/lib/logger";

interface WordInformationDialogProps {
  wordInformationItem: Item | null;
  isOpen: boolean;
  onClose: () => void;
}

const WordInformationDialog = ({
  wordInformationItem,
  isOpen,
  onClose,
}: WordInformationDialogProps) => {
  const { openSharePointDocumentInWordOnline } = useSharePointContext();
  if (!wordInformationItem) return null;
  const handleEditOnline = () => {
    if (!wordInformationItem.driveId || !wordInformationItem.sharepointFileId) {
      logger.warn(
        "User attempted to edit document missing SharePoint metadata",
        {
          operation: "handleEditOnline",
          documentId: wordInformationItem.id,
          documentSource: wordInformationItem.documentSource,
          workspaceId: wordInformationItem.workspaceId,
          hasDriveId: Boolean(wordInformationItem.driveId),
          hasSharepointFileId: Boolean(wordInformationItem.sharepointFileId),
        }
      );
      showErrorToast("Dokumentet mangler SharePoint/OneDrive oplysninger");
      onClose();
      return;
    }
    openSharePointDocumentInWordOnline(
      wordInformationItem.driveId,
      wordInformationItem.sharepointFileId
    );
    onClose();
  };
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Rediger online</DialogTitle>
        </DialogHeader>
        <div className="text-sm">
          Vi gør opmærksom på, at der kan opstå formateringsfejl, når du
          redigerer dokumentet online i browseren.
          <br /> <br />
          Dette kan f.eks. påvirke links, skrifttyper og anden formatering.
          <br /> <br />
          Hvis du har Word installeret, anbefaler vi derfor, at du åbner og
          redigerer dokumentet i Word-programmet, via '{" "}
          <span className="font-semibold whitespace-nowrap inline-flex items-center gap-2">
            <img
              src={MicrosoftWordIcon}
              alt="Microsoft Word icon"
              className="size-4"
            />
            Rediger i Word
          </span>{" "}
          ' i listen af muligheder.
          <br /> <br />
          Hvis du ikke har Word, kan du stadig vælge at åbne dokumentet online.
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="default" onClick={onClose}>
            Luk
          </Button>
          <Button variant="outline" onClick={handleEditOnline}>
            Rediger online
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WordInformationDialog;
